export default "__VITE_ASSET__61e05c47__"